<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>签署人信息列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 检索 -->
            <el-form :model="listQuery" :inline="true">
                <el-form-item label="姓名">
                    <el-input v-model="listQuery.name" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="listQuery.tel" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="公司名称">
                  <el-input v-model="listQuery.companyName" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="账号类型">
                    <el-select v-model="listQuery.type" placeholder filterable clearable>
                        <el-option value="1" label="机构"></el-option>
                        <el-option value="2" label="个人"></el-option>
                    </el-select>
                </el-form-item>

                <el-button type="primary" @click="clickSearch">查询</el-button>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="accountListData" border style="width: 100%" class="table">
                <el-table-column prop="eqbSignId" label="e签宝个人id"></el-table-column>
                <el-table-column prop="signName" label="姓名"></el-table-column>
                <el-table-column prop="signPhone" label="手机号码"> </el-table-column>
                <el-table-column prop="signCertNo" label="身份证号码"></el-table-column>
                <el-table-column prop="eqbOrgId" label="e签宝机构id"></el-table-column>
                <el-table-column prop="orgName" label="公司名称"></el-table-column>
                <el-table-column prop="orgLegalpersonCertName" label="公司法人"></el-table-column>
                <el-table-column prop="orgLegalpersonCertNo" label="法人身份证"></el-table-column>
                <el-table-column prop="type" label="账号类型">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type == 1">机构</el-tag>
                        <el-tag v-if="scope.row.type == 2" type="success">个人</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="isDeleted" label="状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.isDeleted == 0" type="success">启用</el-tag>
                    <el-tag v-if="scope.row.isDeleted == 1" type="danger">停用</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA"></el-table-column>

                <el-table-column prop="creatorName" label="操作" fixed="right" width="200px">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isDeleted==0" type="text" @click="deleteSign(scope.row,1)">停用</el-button>
                        <el-button v-if="scope.row.isDeleted==1" type="text" @click="deleteSign(scope.row,0)">启用</el-button>
<!--                        <el-button type="text" @click="previewBtn(scope.$index, scope.row)"
                            v-loading.fullscreen.lock="fullscreenLoading">预览
                        </el-button>-->
                        <!-- <el-button type="text" @click="cancelSign(scope.row)" class="textWarning"
                            v-if="scope.row.state == 1 && (scope.row.type == 105 || scope.row.type == 110)">取消
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页  -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

    </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data.vue";
// import contractprocedure from '@/script/api/contractprocedure';
import contractApi from "@/script/api/contractapi";
import contractConfigApi from "@/script/api/contractConfigApi";



import signAdressDia from '@/components/workercrm/contract/compent/signAdressDia';

export default {
    components: {
        Pagination,signAdressDia
    },
    data() {
        return {
            showSign: false,
            PDFVisible: false,
            contractUrl: "",

            fullscreenLoading: false,
            accountListData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                name: "",
                tel: "",
                companyName: null,
                type: null,
            },
            singList: [],

        };
    },
    created() {
        this.querySearch();
    },
    methods: {
        clickSearch() {
            this.currentPage = 1;
            this.querySearch();
        },
        // exportExcel() {
        //     let reqData = {
        //         name: this.listQuery.name,
        //         tel: this.listQuery.tel,
        //         state: this.listQuery.state,
        //         type: this.listQuery.type,
        //         isExport: true,
        //         userId: globalData.userInfo.id,
        //     };
        //     contract.$download(reqData, "合同数据明细");
        // },
        //查询
        querySearch() {
            let reqData = {
                name: this.listQuery.name,
                tel: this.listQuery.tel,
                companyName: this.listQuery.companyName,
                type: this.listQuery.type,
                pageNo: this.currentPage,
                pageSize: this.pageSize,
            };
          contractConfigApi.$ajaxEsignManagerGetPageList(reqData).then((res) => {
                if (res.data.errno == 0) {
                    this.total = res.data.data.total;
                    this.accountListData = res.data.data.list;
                }
            });
        },
      deleteSign(row,state){
        let reqData = {
          id: row.id,
          isDeleted: state,
        };
        contractConfigApi.$ajaxdeleteSign(reqData).then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            location.reload();
          }
        });
      }

    },
};
</script>
<style scoped>
.person-dialog .el-select {
    width: 300px;

}

.person-dialog .el-dialog__body {
    height: 160px;

}
</style>
